import React, { Component } from "react";
import CommonUtil from "../../../utils/CommonUtil";
import SecurityUtils from "../../../utils/SecurityUtils";
import ComponentHeader from "../ComponentHeader";
import Table from "./Table";

class TableContainer extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = this.initialState;
    this.nonselectableUpdated = false;
    this.customContextRef = React.createRef();
  }

  initialState = {
    selectRow: SecurityUtils.userHasAnyOfProcessesOrSameParty(
      this.props.deleteRowProcesses
    )
      ? this.props.selectRow
      : undefined,
    sort: this.props.sortInfo
      ? this.sortFromProps()
      : {
          dataField: undefined,
          order: undefined
        }
  };

  getNonSelectableIds() {
    if (this.state.selectRow) {
      let nonselectableIds = this.props.selectRow
        ? this.props.selectRow.nonSelectable
        : null;
      if (!nonselectableIds) {
        nonselectableIds = [];
      }

      const data = this.props.data || [];
      data.forEach(element => {
        if (element.active === false) {
          nonselectableIds.push(element.id);
        }
      });
      let selectRow = {
        ...this.props.selectRow,
        nonSelectable: nonselectableIds,
        nonSelectableClasses: "nonselectableTableRow"
      };
      this.nonselectableUpdated = true;

      this.setState({ selectRow: selectRow });
    }
  }

  componentDidUpdate() {
    if (!this.nonselectableUpdated) {
      this.getNonSelectableIds();
    } else {
      this.nonselectableUpdated = false;
    }

    if (this.props.sortInfo) {
      if (
        this.props.sortInfo.orderBy !== this.state.sort.dataField ||
        this.props.sortInfo.direction !== this.state.sort.order
      ) {
        this.setState({ sort: this.sortFromProps() });
      }
    }
  }

  sortFromProps() {
    return {
      dataField: this.props.sortInfo.orderBy,
      order: this.props.sortInfo.direction
    };
  }

  onContextMenu = (e, row) => {
    const contextMenuItems = this.props.contextMenuItems;
    if (contextMenuItems) {
      e.preventDefault();
      if (this.customContextRef && this.customContextRef.current) {
        this.customContextRef.current.setContextMenu(contextMenuItems, e, row);
      }
    }
  };

  render() {
    return (
      <>
        {this.props.showTableHeader ? (
          <ComponentHeader
            title={this.props.tableLabel}
            addProcesses={this.props.createRowProcesses}
            onAdd={this.props.onCreateRow}
            deleteProcesses={this.props.deleteRowProcesses}
            onDelete={this.props.onDeleteRow}
            onAdvancedSearch={this.props.handleAdvancedSearchShow}
            onAdvancedSearchDelete={this.props.deleteAdvancedSearchParams}
            advancedSearchParametersExist={CommonUtil.objectHasAnyDeepProperty(
              this.props.advancedSearchParams,
              "filterVal"
            )}
            activeFilter={this.props.pageInfo.filters}
            activeProcesses={this.props.changeActiveProcesses}
            onActiveFilterChange={this.props.onActiveButtonChange}
          />
        ) : null}
        <div className="bordered_bottom_rounded">
          <Table
            node={this.props.node}
            columns={this.props.columns}
            data={this.props.data}
            rowEvents={this.rowEvents}
            selectRow={this.state.selectRow}
            onTableChange={this.props.onTableChange}
            paginationOptions={this.props.paginationOptions}
            onRowClick={this.props.onRowClick}
            sort={this.state.sort}
            onContextMenu={this.onContextMenu}
            customContextRef={this.customContextRef}
          />
        </div>
      </>
    );
  }
}

export default TableContainer;
